import { render, staticRenderFns } from "./ProjectManagement.vue?vue&type=template&id=338a304d&scoped=true"
import script from "./ProjectManagement.vue?vue&type=script&lang=js"
export * from "./ProjectManagement.vue?vue&type=script&lang=js"
import style0 from "./ProjectManagement.vue?vue&type=style&index=0&id=338a304d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_f5b883aeb3d125b1f29ae1b8ca7c56aa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338a304d",
  null
  
)

export default component.exports